export default "__VITE_ASSET__21470779__"